import React from 'react';

const NgGuaranteeSection = () => {
  return (
    <section id="guarantee" className="py-12 sm:py-16 md:py-20 bg-white">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="rounded-3xl border border-gray-200 bg-gray-50 px-6 py-8 sm:px-8 sm:py-10">
          <p className="text-xs font-semibold uppercase tracking-[0.2em] text-black/70 mb-3">
            Guarantee
          </p>
          <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-black mb-4">
            60-Day “Double Your Money Back” Guarantee
          </h2>
          <p className="text-base sm:text-lg text-gray-700 leading-relaxed mb-3">
            If you don’t make at least 2× your investment in extra revenue within 60 days, we’ll refund every kobo — and
            give you an extra ₦50,000 for wasting your time.
          </p>
          <p className="text-sm text-gray-700">
            No questions. No fine print. Your growth is our only job.
          </p>
        </div>
      </div>
    </section>
  );
};

export default NgGuaranteeSection;

